import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  FlatList,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppScreens } from "../../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppImages } from "../../../utility/AppImages";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { enumAddEditPublicPrivateScreen } from "../Event/CreatePrivateEventScreen";
import { getHelpTicketsAPI } from "../../../utility/services/getHelpTickets";
import { toast } from "react-toastify";
import PaginationComponent from "../../../utility/pagination/Pagination";
import SupportChatSkeleton from "../../../Components/skeleton-components/SupportChatSkeleton";
import Header from "./Common/Header";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import { Keyboard } from "react-native";
import FilterDropdown from "../../../Components/super-admin/dispute-management-components/FilterDropdow";
import { CommonButton } from "../../../common/CommonButton";
import ReactPlayer from "react-player";
import Separator from "../../../Components/Separator";
import SelectPollModal from "../../../Components/super-admin/dispute-management-components/SelectPollModal";
import { getLoginData } from "../../../utility/AppStoreData";
import {
  adminDisputeGetSpecific,
  adminPublicVoteResult,
  adminWinner,
} from "../../../services/disputesAPI";
import { ShowLoader } from "../../../common/ShowLoader";
import { ScreenBGGradientView } from "../../../common/CommonView";

export default function DisputeDetailScreen({ route }) {
  const routeData = route.params;

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showPollModal, setShowPollModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [disputeDetail, setDisputeDetail] = useState({
    ActionUser1: "",
    ActionUser2: "",
    User1: "",
    User2: "",
    DisputeID: "",
    ProofLocationUser1: "",
    ProofLocationUser2: "",
    ReasonUser1: "",
    ReasonUser2: "",
    eventDetails: {
      eventID: "",
      publicVotingEnabled: false,
      eventTitle: "",
      gameTitle: "",
      participantIDs: [],
      pollEndTime: "",
    },
    Timestamp: "",
    UserRewarded: "",
    winner: null,
  });
  const [accessToken, setAccessToken] = useState(null);
  const [votes, setVotes] = useState({
    playerType: "",
  });
  const [timeLeft, setTimeLeft] = useState({ minutes: "00", seconds: "00" });
  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setAccessToken(data.AccessToken);
      fetchDisputeDetail(data.AccessToken);
    }
  }

  useEffect(() => {
    getLoginUserData();
  }, []);

  const fetchDisputeDetail = async (accessToken) => {
    setShowLoader(true);
    const eventId = routeData.eventId;
    try {
      const response = await adminDisputeGetSpecific(accessToken, eventId);
      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          setDisputeDetail(response.body.dispute);
        }
      } else {
        toast.error(response.body?.error || "Failed to fetch details.");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };
  console.log("disputeDetail", disputeDetail);

  const organizerEvidence = {
    submitted: disputeDetail?.ActionUser1 === "Submitted" ? true : false,
    title: disputeDetail?.eventDetails?.gameTitle,
    description: disputeDetail?.ReasonUser1,

    // mediaType: "video",
    // mediaUrl: "https://example.com/video.mp4",
    mediaType: "image",
    mediaUrl: disputeDetail?.ProofLocationUser1,
  };

  const challengerEvidence = {
    submitted: disputeDetail?.ActionUser2 === "Submitted" ? true : false,
    title: disputeDetail?.eventDetails?.gameTitle,
    description: disputeDetail?.ReasonUser2,
    mediaType: "image",
    mediaUrl: disputeDetail?.ProofLocationUser2,
  };

  const renderEvidenceSection = (playerType, evidence) => {
    const handleMarkAsWinner = async () => {
      setShowLoader(true);
      try {
        // Set the other player as loser
        const otherPlayer =
          playerType === disputeDetail?.eventDetails?.participantIDs[0]
            ? disputeDetail?.eventDetails?.participantIDs[1]
            : disputeDetail?.eventDetails?.participantIDs[0];
        const eventID = disputeDetail?.eventDetails?.eventID;
        const winner = playerType;
        const loser = otherPlayer;
        const DisputeID = disputeDetail?.DisputeID;
        const DisputeTimeStamp = disputeDetail?.Timestamp;

        const response = await adminWinner(
          accessToken,
          eventID,
          winner,
          loser,
          DisputeID,
          DisputeTimeStamp
        );
        if (response.statusCode === 200 || response.statusCode === 201) {
          if (response.body) {
            toast.success("Dispute resolved successfully");
            const winner = response.body.winner;
            setDisputeDetail((prevDetail) => ({
              ...prevDetail,
              UserRewarded: "Resolved",
              winner: winner,
              eventDetails: {
                ...prevDetail.eventDetails,
                publicVotingEnabled: false,
              },
            }));
          }
        } else {
          toast.error(response.body?.error || "Failed to submit winner.");
        }
      } catch (error) {
        console.error("Error resolving dispute:", error);
        toast.error(error.message);
      } finally {
        setShowLoader(false);
      }
    };
    return (
      <View
        style={{
          backgroundColor: AppColors.purple_453B50,
          borderRadius: 20,
          padding: 12,
          height: 590,
          flex: 0.5,
          position: "relative", // For absolute positioning of the button
        }}
      >
        <Text style={[AppFontStyle.MEDIUM_ANYBODY_24, { marginBottom: 12 }]}>
          {playerType}
        </Text>
        {disputeDetail?.eventDetails?.publicVotingEnabled ? (
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {timeLeft.minutes === "00" && timeLeft.seconds === "00" ? (
              <View>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_40, { marginBottom: 8 }]}
                >
                  {votes[playerType] ? votes[playerType] : 0}
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_30,
                    { color: AppColors.white },
                  ]}
                >
                  Votes
                </Text>
              </View>
            ) : (
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_30,
                    { color: AppColors.white },
                  ]}
                >
                  Wait for voting to complete
                </Text>
              </View>
            )}
          </View>
        ) : evidence.submitted ? (
          <>
            <View style={{ gap: 12, flex: 1 }}>
              <View
                style={{
                  backgroundColor: AppColors.gray_353535,
                  borderRadius: 10,
                  height: 300,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {evidence.mediaType === "video" ? (
                  <ReactPlayer
                    url={evidence.mediaUrl}
                    controls={true}
                    width={"100%"}
                    height={"100%"}
                    light={true}
                    playsinline={true}
                    playing={false}
                    preload="none"
                  />
                ) : (
                  <Image
                    source={evidence.mediaUrl}
                    style={{
                      height: "100%",
                      width: "100%",
                      resizeMode: "contain",
                    }}
                  />
                )}
              </View>
              <View>
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_20, { lineHeight: 35 }]}
                >
                  {evidence.title}
                </Text>
                <Text style={[AppFontStyle.REGULAR_ANYBODY_20, {}]}>
                  {evidence.description}
                </Text>
              </View>
            </View>{" "}
          </>
        ) : (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <Text
              style={[AppFontStyle.REGULAR_ANYBODY_30, { textAlign: "center" }]}
            >
              No evidence submitted by this Player
            </Text>
          </View>
        )}
        {disputeDetail?.winner === playerType && (
          <Text style={[AppFontStyle.MEDIUM_ANYBODY_24, { marginBottom: 12 }]}>
            Submitted as winner
          </Text>
        )}

        {/* Mark as Winner Button */}
        <CommonButton
          title="Mark as Winner"
          onTap={handleMarkAsWinner}
          disabled={
            disputeDetail?.UserRewarded.toLowerCase() === "resolved" ||
            !(timeLeft.minutes === "00" && timeLeft.seconds === "00")
          }
          buttonStyle={{
            padding: 10,
            backgroundColor: AppColors.appViolentColor_6D08C3,
            borderRadius: 7,
            shadowOpacity: 0,
            height: 45,
            width: 196,
            position: "absolute",
            bottom: 12,
            right: 12,
          }}
          disabledCustomStyle={{
            backgroundColor: AppColors.appViolentColor_6D08C3,
            opacity: 0.5,
          }}
          textStyle={AppFontStyle.MEDIUM_ANYBODY_20}
        />
      </View>
    );
  };
  const getPublicVotes = async () => {
    setShowLoader(true);
    const eventID = disputeDetail?.eventDetails?.eventID;
    try {
      const response = await adminPublicVoteResult(accessToken, eventID);
      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          if (response.body.votes) {
            setVotes(response.body.votes);
          } else {
            console.log("no vote");
          }
        }
      } else {
        toast.error(response.body?.error || "Failed to fetch details.");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };
  useEffect(() => {
    if (!disputeDetail?.eventDetails?.pollEndTime || !accessToken) return;

    const pollEndTime = new Date(
      disputeDetail?.eventDetails?.pollEndTime
    ).getTime();
    const tenMinutesInMs = 6 * 60 * 1000; // 10 minutes in milliseconds
    const endTimeWithBuffer = pollEndTime + tenMinutesInMs; // Add 10 minutes to pollEndTime
    const now = new Date().getTime();

    // If current time is past the end time (pollEndTime + 10 minutes), set to 00:00 and fetch votes
    if (now >= endTimeWithBuffer) {
      setTimeLeft({ minutes: "00", seconds: "00" });
      if (disputeDetail?.eventDetails?.publicVotingEnabled) {
        getPublicVotes();
      }
      return;
    }

    // Initial calculation before interval starts
    const initialTimeRemain = Math.max(
      0,
      Math.floor((endTimeWithBuffer - now) / 1000)
    );
    if (initialTimeRemain > 0) {
      const minutes = Math.floor(initialTimeRemain / 60);
      const seconds = initialTimeRemain % 60;
      setTimeLeft({
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      });
    }

    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeRemain = Math.max(
        0,
        Math.floor((endTimeWithBuffer - currentTime) / 1000)
      );

      if (timeRemain <= 0) {
        clearInterval(interval);
        setTimeLeft({ minutes: "00", seconds: "00" });
        if (disputeDetail?.eventDetails?.publicVotingEnabled) {
          getPublicVotes();
        }
      } else {
        const minutes = Math.floor(timeRemain / 60);
        const seconds = timeRemain % 60;
        setTimeLeft({
          minutes: String(minutes).padStart(2, "0"),
          seconds: String(seconds).padStart(2, "0"),
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [disputeDetail?.eventDetails?.pollEndTime, accessToken]);
  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <View style={styles.container}>
        <View>
          <View style={{ flexDirection: "row", gap: 10 }}>
            <TouchableOpacity
              onPress={() =>
                // navigation.goBack()
                navigateToScreen(navigation, AppScreens.DisputeManagementScreen)
              }
              style={{ justifyContent: "center" }}
            >
              <Image
                source={AppImages.icArrowLeft}
                style={{
                  height: 24,
                  width: 24,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_32, { color: AppColors.white }]}
            >
              Dispute Details
            </Text>
          </View>
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.grayColor_505050,
              marginTop: 10,
            }}
          />
        </View>

        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{ paddingBottom: 20 }}
          showsVerticalScrollIndicator={true}
          showsHorizontalScrollIndicator={false}
        >
          <View style={{ gap: 44, marginVertical: 50 }}>
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <View style={{ gap: 24 }}>
                <View
                  style={{
                    flexDirection: "row",
                    gap: 164,
                  }}
                >
                  <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_26]}>
                    {disputeDetail?.eventDetails?.eventTitle}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color:
                          disputeDetail?.UserRewarded.toLowerCase() ===
                          "resolved"
                            ? AppColors.green_0DFF00
                            : AppColors.yellow_FF0,
                      },
                    ]}
                  >
                    {disputeDetail?.UserRewarded.toLowerCase() === "resolved"
                      ? "Resolved"
                      : disputeDetail?.UserRewarded}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", gap: 35 }}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_20]}>
                    Dispute ID
                  </Text>
                  <Text style={[AppFontStyle.MEDIUM_ANYBODY_20, {}]}>
                    {disputeDetail?.DisputeID}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", gap: 35 }}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_20]}>
                    Game Title
                  </Text>
                  <Text style={[AppFontStyle.MEDIUM_ANYBODY_20, {}]}>
                    {disputeDetail?.eventDetails?.gameTitle}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", gap: 35 }}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_20]}>
                    Players Involved
                  </Text>
                  <Text style={[AppFontStyle.MEDIUM_ANYBODY_20, {}]}>
                    {disputeDetail?.eventDetails?.participantIDs[0]} vs.{" "}
                    {disputeDetail?.eventDetails?.participantIDs[1]}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", gap: 35 }}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_20]}>
                    Time of Dispute
                  </Text>
                  <Text style={[AppFontStyle.MEDIUM_ANYBODY_20, {}]}>
                    {disputeDetail?.Timestamp}
                  </Text>
                </View>
              </View>
              {disputeDetail?.eventDetails?.publicVotingEnabled && (
                <View>
                  <View
                    style={{
                      backgroundColor: AppColors.grayColor_282828,
                      borderRadius: 12,
                      width: 336,
                      padding: 12,
                    }}
                  >
                    <Text style={[AppFontStyle.BOLD_ANYBODY_18]}>
                      Poll time
                    </Text>
                    <Separator
                      color={AppColors.white}
                      height={1}
                      marginTop={6}
                      marginBottom={6}
                      marginHorizontal={0}
                    />
                    <View
                      style={{
                        marginVertical: 12,
                        flexDirection: "row",
                        gap: 12,
                        justifyContent: "center",
                      }}
                    >
                      <View
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_24,
                            {
                              backgroundColor: AppColors.gray_1E1E1E,
                              padding: 10,
                              borderRadius: 12,
                            },
                          ]}
                        >
                          {timeLeft.minutes}
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { color: AppColors.gray_C4C4C4, marginTop: 2 },
                          ]}
                        >
                          Minutes
                        </Text>
                      </View>
                      <View
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_24,
                            {
                              backgroundColor: AppColors.gray_1E1E1E,

                              padding: 10,
                              borderRadius: 12,
                            },
                          ]}
                        >
                          {timeLeft.seconds}
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { color: AppColors.gray_C4C4C4, marginTop: 2 },
                          ]}
                        >
                          Seconds
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              )}
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <View style={{ flexDirection: "row", gap: 35 }}>
                <Text style={[AppFontStyle.REGULAR_ANYBODY_20]}>
                  Proof Submitted?
                </Text>
                <Text style={[AppFontStyle.MEDIUM_ANYBODY_20, {}]}>
                  Yes (
                  {disputeDetail?.ActionUser1 === "Submitted" &&
                  disputeDetail?.ActionUser1 === "Submitted"
                    ? "both"
                    : disputeDetail?.ActionUser1 === "Submitted"
                    ? disputeDetail?.User1
                    : disputeDetail?.User2}
                  )
                </Text>
              </View>
              {/* <CommonButton
                title="Send for poll"
                onTap={() => {
                  setShowPollModal(true);
                }}
                buttonStyle={{
                  padding: 10,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 7,
                  shadowOpacity: 0,
                  height: 45,
                  width: 196,
                }}
                textStyle={AppFontStyle.MEDIUM_ANYBODY_20}
              /> */}
            </View>
          </View>

          <View style={{ flexDirection: "row", gap: 24 }}>
            {renderEvidenceSection(disputeDetail?.User1, organizerEvidence)}
            {renderEvidenceSection(disputeDetail?.User2, challengerEvidence)}
          </View>
        </ScrollView>
      </View>

      {showPollModal && (
        <SelectPollModal
          showModal={showPollModal}
          setShowModal={setShowPollModal}
        />
      )}
      {<ShowLoader showIndicater={showLoader} isBackGround={true} />}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    emptyStateContainer: {
      flex: 1,
      justifyContent: "center",
      marginTop: 100,
      alignItems: "center",
    },
    emptyStateDescription: {
      color: "white",
      fontSize: 14,
      marginVertical: 10,
    },
    emptyStateText: {
      color: "white",
      fontSize: 16,
      fontWeight: "bold",
    },
    itemWidth: {
      width: "18%",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 220,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      itemWidth: {
        width: 250,
      },
    },
  }
);
